<div class="settled-exchanges-container container-fluid">
  <ng-container *ngIf="settledExchangeResponseError">
    <div class="row">
      <h3>Recently Settled Exchanges</h3>
    </div>
    <invd-fm-message-alerts [messageTitle]="messageTitle" [messageBody]="messageBody">
    </invd-fm-message-alerts>
  </ng-container>

  <ng-container *ngIf="!settledExchangeResponseError">
    <h3>Recently Settled Exchanges</h3>
    <div class="fm-cdx-table">
      <table class="fm-cdx-table__static">
        <thead>
          <tr class="th_row">
            <th class="th_column sortable-column">
              <span>Confirmation #</span>
              <a class="column-name" (click)="sortByGridByColumnName('exchangeConfirmationNumber')">
                <i
                  class="sorting-icon-down fa fa-caret-down {{
                    presentSortedColumn === 'exchangeConfirmationNumber'
                      ? presentSortedColumnIsAscending
                        ? ''
                        : 'in-active-icon'
                      : 'in-active-icon'
                  }}"
                ></i>
                <i
                  class="sorting-icon-up fa fa-caret-up {{
                    presentSortedColumn === 'exchangeConfirmationNumber'
                      ? presentSortedColumnIsAscending
                        ? 'in-active-icon'
                        : ''
                      : 'in-active-icon'
                  }}"
                ></i>
              </a>
            </th>
            <th class="th_column">Deal/Trust #</th>
            <th class="th_column">Deal Type</th>
            <th class="th_column">settlement</th>
            <th class="th_column">Dealer</th>
            <th class="th_column">Bonds Exchanged</th>
            <th class="th_column">Settlement Date</th>
            <th class="th_column th_column--is-numeric">Original Balance Exchanged</th>
          </tr>
        </thead>
        <tbody>
          <tr
            class="td_row"
            *ngFor="
              let settledExchange of settledExchangesData?.settledExchanges | paginate: config;
              let j = index;
              trackBy: trackByIdentity
            "
          >
            <td class="td_cell">
              <button
                class="confirmationNumberBtn"
                (click)="retrieveExchangeData((config.currentPage - 1) * 50 + j)"
              >
                <a>{{ settledExchange?.exchangeConfirmationNumber }}</a>
              </button>
            </td>
            <td class="td_cell">{{ settledExchange?.dealNumber }}</td>
            <td class="td_cell deal-type--min-width">{{ settledExchange?.displayDealType }}</td>
            <td class="td_cell">{{ settledExchange?.exchangeTypeFilter }}</td>
            <td class="td_cell dealer--min-width">{{ settledExchange?.dealerName }}</td>
            <td class="td_cell">{{ settledExchange?.bondsExchanged }}</td>
            <td class="td_cell">
              {{
                settledExchange?.exchangeSettlementDate | date: 'MM/dd/yyyy' : 'America/New_York'
              }}
            </td>
            <td class="td_cell td_cell--is-numeric">
              {{ settledExchange?.origBalExchanged | currency: 'USD' : 'symbol' : '1.0' }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <pagination-template
      #p="paginationApi"
      [id]="config.id"
      (pageChange)="config.currentPage = $event"
      *ngIf="displayPagination"
    >
      <nav
        aria-label="Page navigation"
        class="settled-exchanges-pagination d-flex justify-content-end"
      >
        <ul class="pagination">
          <li class="page-item pagination-previous" [class.disabled]="p.isFirstPage()">
            <a class="page-link" (click)="p.previous()">
              <span aria-hidden="true">PREV</span>
            </a>
          </li>

          <li
            class="page-item"
            *ngFor="let page of p.pages; trackBy: trackByIdentity"
            [class.active]="p.getCurrent() === page.value"
          >
            <a
              class="page-link"
              [ngClass]="{ ellipse: page.label === '...' }"
              (click)="p.setCurrent(page.value)"
              *ngIf="p.getCurrent() !== page.value"
            >
              <span>{{ page.label }}</span>
            </a>
            <a class="page-link" *ngIf="p.getCurrent() === page.value">
              <span>{{ page.label }}</span>
            </a>
          </li>

          <li class="page-item pagination-next" [class.disabled]="p.isLastPage()">
            <a class="page-link" (click)="p.next()">
              <span aria-hidden="true">NEXT</span>
            </a>
          </li>
        </ul>
      </nav>
    </pagination-template>
  </ng-container>
</div>
